import auth from "@/utils/auth";
import { useAppStore } from "@/store";
import { createRouter, createWebHistory, isNavigationFailure, NavigationFailureType } from "vue-router";
import Home from "@/views/home.vue";
import NotFound from "@/views/not-found.vue";
import Account from "@/views/account.vue";
import Admin from "@/views/admin.vue";
import Tournaments from "@/views/tournaments.vue";
import Tournament from "@/views/tournament.vue";
import Leagues from "@/views/leagues.vue";
import League from "@/views/league.vue";
import { SigningIn } from "vue-app-components";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: "Home",
      path: "/",
      alias: "/index.html",
      component: Home,
      meta: {}
    },
    {
      name: "SigningIn",
      path: "/signing-in",
      component: SigningIn,
      meta: {}
    },
    {
      name: "Account",
      path: "/account",
      component: Account,
      meta: { requiresAuth: true }
    },
    {
      name: "Admin",
      path: "/admin",
      component: Admin,
      meta: { requiresAuth: true }
    },
    {
      name: "tournaments",
      path: "/tournaments",
      component: Tournaments,
      meta: { requiresAuth: true }
    },
    {
      name: "tournament",
      path: "/tournaments/:id",
      component: Tournament,
      meta: { requiresAuth: true }
    },
    {
      name: "tournamentNew",
      path: "/tournaments/new",
      meta: { requiresAuth: true }
    },
    {
      name: "leagues",
      path: "/leagues",
      component: Leagues,
      meta: { requiresAuth: true }
    },
    {
      name: "league",
      path: "/leagues/:id",
      component: League,
      meta: { requiresAuth: true }
    },
    {
      name: "leagueNew",
      path: "/leagues/new",
      meta: { requiresAuth: true }
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: NotFound
    }
  ]
});

router.beforeEach((to, from) => {
  const isAuthenticated = !!(auth.auth && auth.auth.currentUser);

  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    const redirect = (({ name, params, query }) => { return { name, params, query }; })(to);
    auth.openDialog(redirect);
    return false;
  } else if (to.name === "Admin" && location.hostname !== "localhost") {
    return { name: "NotFound" };
  } else if (to.name === "tournamentNew") {
    const store = useAppStore();
    return store.user.createTournament().then((id) => {
      return { name: "tournament", params: { id } };
    });
  } else if (to.name === "leagueNew") {
    const store = useAppStore();
    return store.user.createLeague().then((id) => {
      return { name: "league", params: { id } };
    });
  }
});

router.updateQueryParams = function (params) {
  return this.replace({
    query: Object.assign({}, this.currentRoute.value.query, params)
  })
    .catch((e) => {
      if (!(isNavigationFailure(e, NavigationFailureType.duplicated) || isNavigationFailure(e, NavigationFailureType.aborted))) {
        throw Error(e);
      }
    });
};

router.removeQueryParam = function (name) {
  const query = Object.assign({}, this.currentRoute.value.query);
  if (name in query) {
    delete query[name];
    this.replace({ query })
      .catch((e) => {
        if (!isNavigationFailure(e, NavigationFailureType.cancelled)) {
          throw Error(e);
        }
      });
  } else {
    return Promise.resolve();
  }
};

export default router;